var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-print-content" },
    [
      _c("div", { staticClass: "boss-table-title pega-print-title" }, [
        _c("div", { staticClass: "pega-ta-right" }, [
          _c("span", { attrs: { "data-test": "company-name" } }, [
            _vm._v(_vm._s(_vm.entryCompanyName) + "\n        "),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _vm.isDuplicatedEntries
                ? _c(
                    "span",
                    {
                      staticClass:
                        "boss-status-label pega-status-label pega-status-label-top-0",
                      attrs: { "data-test": "label-duplicated-entries" },
                    },
                    [_vm._v("重複応募\n          ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isSimpleEntryForm
                ? _c(
                    "span",
                    {
                      staticClass:
                        "boss-status-label pega-status-label pega-status-label-top-0",
                      attrs: { "data-test": "label-entry-form" },
                    },
                    [_vm._v("自己PR不要\n          ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { attrs: { "data-test": "header-info" } }, [
                _vm._v("応募者：" + _vm._s(_vm.userName) + "様"),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("entry-print-selection", {
        attrs: {
          "entry-id": Number(_vm.$route.params.entryId),
          selections: _vm.selections,
        },
      }),
      _vm._v(" "),
      _c("p", [_vm._v("アプローチ状況")]),
      _vm._v(" "),
      _c("approached-summary", {
        attrs: {
          "approached-summaries": _vm.approachedSummaries,
          "is-print-preview": true,
        },
      }),
      _vm._v(" "),
      _c("p", [_vm._v("直近のスカウト文面")]),
      _vm._v(" "),
      _vm.hasScoutMessage
        ? _c(
            "div",
            { staticClass: "boss-message-wrap" },
            [
              _c("entry-message-history-scout", {
                attrs: {
                  body: _vm.scoutMessage.body,
                  subject: _vm.scoutMessage.subject,
                  date: _vm.scoutMessage.date,
                  job: _vm.scoutMessage.job,
                  "expiration-date": _vm.scoutMessage.expirationDate,
                  "special-favors": _vm.scoutMessage.specialFavors,
                },
              }),
            ],
            1
          )
        : _c("span", { staticClass: "pega-no-scout-label" }, [
            _vm._v("\n    直近のスカウトなし\n  "),
          ]),
      _vm._v(" "),
      _c("p", { staticClass: "boss-page-break" }),
      _vm._v(" "),
      _vm.loaded.isFetchResumeCompleted
        ? _c("entry-detail-resume", {
            attrs: {
              "entry-id": Number(_vm.$route.params.entryId),
              "header-user-name": _vm.userName,
              "entry-company-name": _vm.entryCompanyName,
              "is-duplicated-entries": _vm.isDuplicatedEntries,
              "is-simple-entry-form": _vm.isSimpleEntryForm,
              "parent-resume": _vm.resume,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "boss-page-break" }),
      _vm._v(" "),
      _c("entry-detail-career-resume", {
        attrs: {
          "entry-id": Number(_vm.$route.params.entryId),
          "header-user-name": _vm.userName,
          "entry-company-name": _vm.entryCompanyName,
          "is-duplicated-entries": _vm.isDuplicatedEntries,
          "is-simple-entry-form": _vm.isSimpleEntryForm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-layout boss-layout-gap-between" }, [
      _c("div", [
        _c(
          "div",
          { staticClass: "boss-resume-sheet-title pega-resume-sheet-title" },
          [_vm._v("\n        選考状況\n      ")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }